function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import values from 'ramda/src/values';
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
export var RETRIEVE_SHARED_ENTITLEMENTS = {
  BEGIN: 'RETRIEVE_SHARED_ENTITLEMENTS_BEGIN',
  SUCCESS: 'RETRIEVE_SHARED_ENTITLEMENTS_SUCCESS',
  FAILURE: 'RETRIEVE_SHARED_ENTITLEMENTS_FAILURE'
};
export var retrieveSharedEntitlements = function retrieveSharedEntitlements(customerId) {
  var searchTerm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var pageNumber = arguments.length > 2 ? arguments[2] : undefined;
  var pageSize = arguments.length > 3 ? arguments[3] : undefined;
  return function (dispatch) {
    return thunkHelper(dispatch, values(RETRIEVE_SHARED_ENTITLEMENTS), {
      method: 'post',
      url: 'SubscriberManagement/RetrieveEntitlementBalances',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        GroupEntitlement: true,
        SharedEntitlementSearchByName: searchTerm,
        EntitlementPagination: {
          PageNumber: pageNumber,
          PageSize: pageSize
        }
      }
    });
  };
};
export var RETRIEVE_ENTITLEMENT_USAGE = {
  BEGIN: 'RETRIEVE_ENTITLEMENT_USAGE_BEGIN',
  SUCCESS: 'RETRIEVE_ENTITLEMENT_USAGE_SUCCESS',
  FAILURE: 'RETRIEVE_ENTITLEMENT_USAGE_FAILURE'
};
export var retrieveEntitlementUsage = function retrieveEntitlementUsage(customerId, entitlementIdentifier, pageNumber, pageSize) {
  return function (dispatch) {
    return thunkHelper(dispatch, values(RETRIEVE_ENTITLEMENT_USAGE), {
      method: 'post',
      url: 'SubscriberManagement/RetrieveEntitlementUsage',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        PageSize: pageSize,
        PageNumber: pageNumber,
        EntitlementIdentifier: entitlementIdentifier
      }
    });
  };
};
export var SET_SHARED_ENTITLEMENTS_PAGE_SIZE = 'SET_SHARED_ENTITLEMENTS_PAGE_SIZE';
export var setSharedEntitlementsPageSize = function setSharedEntitlementsPageSize(pageSize) {
  return {
    type: SET_SHARED_ENTITLEMENTS_PAGE_SIZE,
    payload: pageSize
  };
};
export var SET_SHARED_ENTITLEMENTS_CURRENT_PAGE = 'SET_SHARED_ENTITLEMENTS_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_SHARED_ENTITLEMENTS_CURRENT_PAGE,
    payload: page
  };
};
export var SET_SELECTED_SHARED_ENTITLEMENT_INDEX = 'SET_SELECTED_SHARED_ENTITLEMENT_INDEX';
export var setSelectedSharedEntitlementIndex = function setSelectedSharedEntitlementIndex(entitlementIndex) {
  return {
    type: SET_SELECTED_SHARED_ENTITLEMENT_INDEX,
    payload: entitlementIndex
  };
};
export var UPDATE_ENTITLEMENT_SHARE_STATUS = {
  BEGIN: 'UPDATE_ENTITLEMENT_SHARE_STATUS_BEGIN',
  SUCCESS: 'UPDATE_ENTITLEMENT_SHARE_STATUS_SUCCESS',
  FAILURE: 'UPDATE_ENTITLEMENT_SHARE_STATUS_FAILURE'
};
export var updateEntitlementShareStatus = function updateEntitlementShareStatus(customerId, entitlementIdentifier, shareStatus) {
  return function (dispatch) {
    return thunkHelper(dispatch, values(UPDATE_ENTITLEMENT_SHARE_STATUS), {
      method: 'post',
      url: 'SubscriberManagement/UpdateEntitlementShareStatus',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        SharedStatus: shareStatus,
        EntitlementIdentifier: entitlementIdentifier
      }
    });
  };
};
export var SET_ENTITLEMENT_SHARE_STATUS = 'SET_ENTITLEMENT_SHARE_STATUS';
export var setEntitlementShareStatus = function setEntitlementShareStatus(entitlementIndex, sharingStatus) {
  return {
    type: SET_ENTITLEMENT_SHARE_STATUS,
    payload: {
      index: entitlementIndex,
      sharingStatus: sharingStatus
    }
  };
};
export var RESET_SHARED_ENTITLEMENT_TAB_DATA = 'RESET_SHARED_ENTITLEMENT_TAB_DATA';
export var resetSharedEntitlementTabData = function resetSharedEntitlementTabData() {
  return {
    type: RESET_SHARED_ENTITLEMENT_TAB_DATA
  };
};
export var SET_ENTITLEMENTS_PAGINATION_DATA = 'SET_ENTITLEMENTS_PAGINATION_DATA';
export var setEntitlementsPaginationData = function setEntitlementsPaginationData(pageNumber, pageSize) {
  return {
    type: SET_ENTITLEMENTS_PAGINATION_DATA,
    payload: {
      pageNumber: pageNumber,
      pageSize: pageSize
    }
  };
};
export var SET_ENTITLEMENTS_SEARCH_TERM = 'SET_ENTITLEMENTS_SEARCH_TERM';
export var setEntitlementsSearchTerm = function setEntitlementsSearchTerm(searchTerm) {
  return {
    type: SET_ENTITLEMENTS_SEARCH_TERM,
    payload: searchTerm
  };
};